export * from 'inpc/constants/inpc_constants';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/constants/index.js